import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import { useFormContext } from "react-hook-form";

type Props = Omit<
  React.ComponentPropsWithoutRef<typeof Switch>,
  "checked" | "onCheckedChange"
> & {
  name: string;
  onCheckedChange?: (checked: boolean) => void;
};

export const SwitchInput = ({
  name,
  onCheckedChange,
  disabled,
  ...rest
}: Props) => {
  const form = useFormContext();

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormControl>
            <Switch
              {...rest}
              checked={!!field.value}
              onCheckedChange={(checked) => {
                field.onChange(checked);
                onCheckedChange?.(checked);
              }}
              disabled={disabled}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
